import { render, staticRenderFns } from "./AiAssistant.vue?vue&type=template&id=69ed2664&scoped=true&"
import script from "./AiAssistant.vue?vue&type=script&lang=js&"
export * from "./AiAssistant.vue?vue&type=script&lang=js&"
import style0 from "./AiAssistant.vue?vue&type=style&index=0&id=69ed2664&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ed2664",
  null
  
)

export default component.exports